import { render } from "./StopSend.vue?vue&type=template&id=077fe1fa&scoped=true&ts=true"
import script from "./StopSend.vue?vue&type=script&lang=ts"
export * from "./StopSend.vue?vue&type=script&lang=ts"

import "./StopSend.vue?vue&type=style&index=0&id=077fe1fa&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-077fe1fa"]])

export default __exports__